import React from 'react';

const ProgressBar = ({ current = 0, total }) => {
    let progress = Math.ceil((current / total) * 100);
    return (
        <div className="progress">
            <div
                className="progress-bar"
                role="progressbar"
                aria-valuenow={progress}
                aria-valuemin="0"
                aria-valuemax="100"
                style={{ width: `${progress}%` }}
            >
                <span className="sr-only">{progress}% Complete</span>
            </div>
        </div>
    );
};
export default ProgressBar;
